import { AppService } from "../../api";

type AppServiceKeys = "sib" | "rms-mapper" | "sdp" | "zone";

export type Environment = Record<AppServiceKeys, string>;
export type MobileCheckoutEnvironment = Pick<Environment, "rms-mapper"> &
  Partial<Omit<Environment, "rms-mapper">>;

export let environment: Environment = {
  "rms-mapper": "",
  sib: "",
  sdp: "",
  zone: "",
};

export const updateEnvironment = (newValue: Environment) => {
  environment = {
    ...environment,
    ...newValue,
  };
};

export const convertServicesToEnvironment = (
  services: AppService[],
): MobileCheckoutEnvironment => {
  const converted = services.reduce<Record<string, string>>((result, service) => {
    result[service.key] = service.url;
    return result;
  }, {});

  if (!isMobileCheckoutEnvironment(converted)) {
    throw new Error("Mobile App Checkout requires the rms-mapper service");
  }
  return converted;
};

export function isMobileCheckoutEnvironment(
  value: unknown,
): value is MobileCheckoutEnvironment {
  if (!value || typeof value !== "object") return false;
  const rmsMapper = (value as Record<string, unknown>)["rms-mapper"];
  return typeof rmsMapper === "string" && rmsMapper.trim().length > 0;
}
